import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import { ValidNode } from '../../../types';
import { FC } from 'react';
import {
    tableStyle,
    tableHeadingStyle,
    tableDataStyle,
    tableCaptionStyle,
    tableDataSourceStyle
} from './TableEntry.styles.css';

export type TableEntryProps = {
    node: ValidNode;
    type?: string;
};

export type TableProps = {
    data?: [];
    id?: string;
};

const TableHeader: FC<TableProps> = ({ data, id }) => (
    <thead>
        <tr>
            {data?.map((cellData: string, key: number) => (
                <th
                    className={tableHeadingStyle}
                    scope="col"
                    key={`tablehead-${id}-row-${key}`}
                >
                    {cellData}
                </th>
            ))}
        </tr>
    </thead>
);

const TableBody: FC<TableProps> = ({ data, id }) => {
    return (
        <tbody>
            {data?.map((rowData: [], key: number) => (
                <tr key={`table-${id}-row-${key}`}>
                    {rowData?.map((cellData: string, key: number) => (
                        <td
                            className={tableDataStyle}
                            key={`table-${id}-cell-${key}`}
                        >
                            {cellData}
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>
    );
};

const TableEntry: FC<TableEntryProps> = ({ node }) => {
    const { fields, sys } = node.data.target;
    const [tableHeaders, ...tableBody] = fields.table?.tableData || [];
    const id = sys?.id;

    return (
        <div>
            <table className={tableStyle}>
                {fields.table?.tableTitle ? (
                    <caption className={tableCaptionStyle}>
                        {fields.table.tableTitle}
                    </caption>
                ) : null}
                <TableHeader data={tableHeaders} id={id} />
                <TableBody data={tableBody} id={id} />
            </table>
            {fields.source ? (
                <p className={`${tableDataSourceStyle} ${fontGroups.spoon}`}>
                    {fields.source}
                </p>
            ) : null}
        </div>
    );
};

export default TableEntry;
